import { ApiResponse } from 'apisauce';

import config from '../../config';
import { CryptocurrenciesEnum, CurrencyEnum, PaymentProviderEnum } from '../enums';
import { GetCryptoRateParams, GetCryptoRateResponse } from '../models/payment/types';

import { BaseRequestService } from './BaseRequest.service';
import { IPaymentService } from './types';

const API_PATH: any = {
  getCardTransferStatus: '/Payment/card-transfer-status/',
  getCryptoRate: '/Payment/crypto-rate/',
};

export class PaymentService extends BaseRequestService implements IPaymentService {
  protected getBaseUrl(): string {
    return config.payment.url;
  }

  /**
   * For DSK this call is needed in order to:
   *  1. Get card transfer status - PaymentPspStatusEnum (because DSK does not ping our services when the staus is updated)
   *  2. Update the status in CRM DB (see PaymentStatusEnum)
   */
  public getCardTransferStatus(paymentRef: string, paymentProvider?: PaymentProviderEnum) {
    let url = API_PATH.getCardTransferStatus + paymentRef;

    if (paymentProvider) {
      url = `${url}?paymentProvider=${paymentProvider}`;
    }

    return this.api.get(url);
  }

  public getCryptoRate({
    currency = CurrencyEnum.USD,
    cryptoSymbol = CryptocurrenciesEnum.USDT,
    amount,
  }: GetCryptoRateParams = {}) {
    const params: Record<string, string> = { currency, cryptoSymbol };

    if (amount !== undefined) {
      params.amount = amount;
    }

    return this.api.get(API_PATH.getCryptoRate, params) as Promise<ApiResponse<GetCryptoRateResponse>>;
  }
}
